<template>
  <div style="background-color: #fff;">
    <van-nav-bar title="闲置" fixed right-text="关注" @click-right="onClickRight">
      <template #left>
        <van-icon name="arrow-down" size="18" />
        <div style="color: #1baeae;" v-on:click="$router.push('/city')">{{city.area_name}}</div>
      </template>
    </van-nav-bar>
    <div style="height:46px"></div>
    <vue-swpier :items="slide" autoplay="5000"></vue-swpier>

    <van-tabs v-model="active" sticky @change="tabChange" color="#1baeae" title-active-color="#1baeae" title-inactive-color="#1baeae">
      <van-tab :title="t.name" v-for="t in tabs" :key="t.id" :name="t.id">
        <van-list
          class="goodsList"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <router-link
            :to="'/second/detail/'+item.id"
            class="item"
            v-for="item in list"
            :key="item.id"
          >
            <van-image
              style="background-color:#F7F8FA"
              width="100%"
              height="50vw"
              fit="cover"
              radius="10px"
              :src="GLOBAL.IMG + item.img[0]"
            />
            <div class="title">{{item.title}}{{item.content}}</div>

            <div class="userInfo">
              <div class="av">
                <img :src="item.avatar" />
              </div>
              <div class="user-name">{{item.user_nickname}}</div>
            </div>
            <div style="padding:0 0 10px 10px; color: #333;">{{item.area_name}} {{item.create_time_str}}</div>
          </router-link>
        </van-list>
      </van-tab>
    </van-tabs>
    <i class="add iconfont iconfabu" v-on:click="secondAdd()"></i>
    <TabBar active="3" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
import vueSwpier from "@/components/vueSwiper.vue";
import Vue from "vue";
import { Tab, Tabs } from "vant";
import { Icon } from "vant";
import wx_share from '../../common/wx_share.js';
Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
export default {
  name: "secondList",
  components: {
    TabBar,
    vueSwpier
  },
  data() {
    return {
      slide: [],
      list: [],
      loading: false,
      finished: false,
      cPage: 1,
      tabs: [
        { name: "转卖", id: 21 },
        { name: "求购", id: 19 }
      ],
      active: 0,
      type: 21,
      city: { area_id: 2, area_name: "北京市" },
      user: { token: "",user:{id:0} },
    };
  },
  methods: {
    onClickRight(){
        this.$router.push("/article/detail/71");
    },
    getSlide(id) {
      this.$http
        .get(this.GLOBAL.API + "s_slide/index/slide?id=" + id, {
          params: {},
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.slide = data.data;
          }
        });
    },
    tabChange(name) {
      this.type = name;
      this.list = [];
      this.cPage = 1;
      this.loading = false;
      this.finished = false;
      // this.onLoad();
    },
    onLoad() {
      this.$http
        .get(this.GLOBAL.API + "s_xianyu/Supply/supply_list", {
          params: {
            id: this.type,
            page: this.cPage,
            city_id: this.city.area_id
          }, //id=19求购，id=21出售
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          this.loading = false;
          if (this.cPage >= data.data.last_page) {
            this.finished = true;
          } else {
            this.cPage++;
          }
          if (data.code == 1) {
            this.list = this.list.concat(data.data.data); //= data.data.data;
          }
        });
    },
    secondAdd() {
      this.$router.push("/second/add");
    }
  },
  mounted() {
    if (localStorage.getItem("city")) {
      this.city = JSON.parse(localStorage.getItem("city"));
    }
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
    this.getSlide(7);
    let item = {"post_title":"亿家一家二手信息","desc":"亿家一家二手信息,应有尽有，只要关注，都有您想要的。","thumbnail":"http://yijia.sihandbms.cn/upload/default/logo.jpg"}
    wx_share.wx_share(this.GLOBAL.API,this.user,item);
  },
  beforeRouteEnter(to,from,next){
      if(from.name=='city'){
          to.meta.keepAlive = false;
      }else{
          to.meta.keepAlive = true;
      }
    //   console.log(to.name);
    //   console.log(from.name);
      next()

  }
};
</script>
<style lang="scss" scoped>
.goodsList {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  text-align: left;
  .item {
    margin-top: 5px;
    background-color: #ffffff;
    width: 49.5%;
    border-radius: 10px;
    border: 1px solid #fff;
    .title {
      line-height: 30px;
      height: 30px;
      overflow: hidden;
      padding: 0 5px 10px 10px;
      color: #1baeae;
    }
    .userInfo {
      margin-top: 4px;
      line-height: 30px;
      height: 40px;
      overflow: hidden;
      display: flex;
      padding: 0 10px 6px 10px;
      color: #333;
      .av {
        img {
          width: 30px;
          height: 30px;
          border-radius: 15px;
        }
      }
      .user-name {
        padding-left: 10px;
      }
    }
  }
}
.add {
  position: fixed;
  bottom: 60px;
  right: 10px;
  font-size: 50px;
  color: #1baeae;
}
</style>